angular.module('impactx.suppliercatalogupload').controller('CatalogSupplierImportCtrl', [
    '$scope',
    '$mdDialog',
    'data',
    'themeFactory',
    'trns',
    'hideImportDateType',
    CatalogSupplierImportCtrl]);

function CatalogSupplierImportCtrl($scope, $mdDialog, data, themeFactory, trns, hideImportDateType) {
    $scope.data = data;
    $scope.trns = trns;
    $scope.theme = themeFactory.getTheme();
    $scope.minDate = new Date();
    $scope.dateInvalid = false;
    $scope.dateInPast = false;
    $scope.errorMessage = $scope.trns.noFreeDate;
    $scope.hours = [];
    $scope.hideImportDateType = hideImportDateType;

    for (var i = 0; i < 23; i++) {
        $scope.hours.push(i);
    }
    $scope.minutes = [];
    for (var j = 0; j < 60; j = j + 5) {
        $scope.minutes.push(j);
    }
    var self = this;

    $scope.$watch(function () {
            return $scope.data.importDate.dateValue;
        },
        function (newValue, oldValue) {
            if (newValue !== oldValue) {
                $scope.dateInvalid = !self.checkDate();
                $scope.dateInPast = !self.checkDateInPast();
                setValidity(!$scope.dateInvalid, !$scope.dateInPast);
            }
        }
    );
    $scope.$watch(function () {
            return $scope.data.importDate.hour;
        },
        function (newValue, oldValue) {
            if (newValue !== oldValue) {
                $scope.dateInvalid = !self.checkDate();
                $scope.dateInPast = !self.checkDateInPast();
                setValidity(!$scope.dateInvalid, !$scope.dateInPast);
            }
        }
    );
    $scope.$watch(function () {
            return $scope.data.importDate.minute;
        },
        function (newValue, oldValue) {
            if (newValue !== oldValue) {
                $scope.dateInvalid = !self.checkDate();
                $scope.dateInPast = !self.checkDateInPast();
                setValidity(!$scope.dateInvalid, !$scope.dateInPast);
            }
        }
    );

    $scope.$watch(function () {
            return $scope.data.importDateType.setId;
        },
        function (newValue, oldValue) {
            if (newValue !== oldValue) {
                $scope.dateInvalid = !self.checkDate();
                $scope.dateInPast = !self.checkDateInPast();
                setValidity(!$scope.dateInvalid, !$scope.dateInPast);
            }
        }
    );

    var setValidity = function (dateInvalid, dateInPast) {
        if (impactX.isDefined($scope, 'dialogData.importDateHour')) {
            $scope.dialogData.importDateHour.$setValidity('invalidDate', dateInvalid);
            $scope.dialogData.importDateHour.$setValidity('dateInPast', dateInPast);
        }
    };

    self.checkDateInPast = function () {
        if ($scope.data.importDateType.setId == 2 && $scope.data.importDate.dateValue) {
            var currentDate = new Date();
            var currentSetData = new Date($scope.data.importDate.dateValue.getTime());
            currentSetData.setHours($scope.data.importDate.hour);
            currentSetData.setMinutes($scope.data.importDate.minute);
            currentSetData.setSeconds(0);
            currentSetData.setMilliseconds(0);
            if (currentDate.getTime() > currentSetData.getTime()) {
                return false;
            }
        }
        return true;
    };

    self.checkDate = function () {
        if ($scope.data.importDateType.setId == 2) {
            if (!$scope.data.importDate.dateValue) {
                return false;
            }
            if (!$scope.data.canImportAtAnyTime) {
                if ($scope.data.importDate.dateValue.getDay() != 6 && $scope.data.importDate.dateValue.getDay() != 0) {
                    if ($scope.data.importDate.hour < 18 || $scope.data.importDate.hour > 22 || ($scope.data.importDate.hour == 22 && $scope.data.importDate.minute > 0)) {
                        return false;
                    }
                }
            }
        }
        return true;
    };

    this.cancel = function () {
        $mdDialog.cancel();
    };
    this.answer = function () {
        if ($scope.data.importDateType.setId == 2 && !self.checkDateInPast()) {
            $scope.dateInPast = true;
            return false;
        }
        if (!$scope.data.canImportAtAnyTime && $scope.data.importDateType.setId == 2) {
            if ($scope.data.importDate.dateValue.getDay() != 6 && $scope.data.importDate.dateValue.getDay() != 0) {
                if ($scope.data.importDate.hour < 18 || $scope.data.importDate.hour > 22 || ($scope.data.importDate.hour == 22 && $scope.data.importDate.minute > 0)) {
                    $scope.errorMessage = $scope.trns.noFreeDate;
                    return false;
                }
            }
        }
        $mdDialog.hide($scope.data);
    };

    $scope.hourFilter = function (item) {
        if (!!impactX.isDefined($scope, 'data.importDate.dateValue.getDay')) {
            var isWeekend = $scope.data.importDate.dateValue.getDay() == 6 || $scope.data.importDate.dateValue.getDay() == 0;
            return isWeekend || $scope.data.canImportAtAnyTime || (item >= 18 && item <= 22)
        }
        return true; // prevent clearing the hour input if no date is set
    };
}

angular.module('impactx.suppliercatalogupload').filter('minute', function () {
    return function (input) {
        var s = input + "";
        while (s.length < 2) {
            s = "0" + s;
        }
        return s;
    };
});